import * as SignalR from '@microsoft/signalr';
import { oktaAuth } from '../auth';
import { setConnectionState, checkVersion } from 'store/actions';

const apiPath = process.env.REACT_APP_API_PATH;
let shouldBlockIfVersionMismatch = true;
let connectionTries = 1;
let store = null;

export let connection;

const getTimeout = () => {
  if (connectionTries < 10) {
    return connectionTries * 1000;
  } else {
    return 300000; // 5 mins
  }
}

export const create = (reduxStore) => {
  store = reduxStore;
  connection = new SignalR.HubConnectionBuilder().withUrl(`${apiPath}/revuehub`, { accessTokenFactory: () => oktaAuth.getAccessToken() })
    .build();
}

export const start = async callback => {
  if (!isConnected()) {
    connection
      .start(() => {
        callback();
      })
      .then(() => {
        store.dispatch(checkVersion(shouldBlockIfVersionMismatch)); // If this is the first connection success after initial app launch, and version mismatch occurs, show blocking modal because user has cached client version.
        connectionTries = 1;
        if (store.getState().appState.connectionState !== 'connected') {
          store.dispatch(setConnectionState('connected'));
        }
        shouldBlockIfVersionMismatch = false; // Set to false because subsequent connection successes with a version mismatch indicate a reconnect after new version was pushed (show New Version Available toast instead)
      })
      .catch(err => {
        connectionTries = connectionTries + 1;
        console.log(`Error starting revuehub, retrying in ${getTimeout() / 1000} secs`, err);
        setTimeout(() => start(), getTimeout());
      });
  }
};

export const isConnected = () => {
  return connection.state === SignalR.HubConnectionState['Connected'];
};

export const reconnect = async () => {
  if (connection.state === SignalR.HubConnectionState['Disconnected']) {
    await start();
  }
};

const revueHubConnection = { connection, create, start, isConnected, reconnect };
export default revueHubConnection;